// Frontend-only prototype: contact messages are stored in localStorage.
// No backend/email service is connected — this is MOCKED for demo purposes.

const STORAGE_KEY = "stoyga_messages";

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
}

export function saveContactMessage({ name, email, message }) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    list.push({ name, email, message, submittedAt: new Date().toISOString() });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch (e) {
    // localStorage unavailable — fail silently, UX still proceeds
  }
  return { success: true };
}
